export enum EndCourseValidationStatus {
  Error = "error",
  Warning = "warning",
  Success = "success",
}
